// 日時を「3時間前」のような相対表記にする
export const formatRelativeTime = (date: Date): string => {
  const diffSec = Math.floor((Date.now() - date.getTime()) / 1000)
  if (diffSec < 60) return 'たった今'

  const diffMin = Math.floor(diffSec / 60)
  if (diffMin < 60) return `${diffMin}分前`

  const diffHour = Math.floor(diffMin / 60)
  if (diffHour < 24) return `${diffHour}時間前`

  const diffDay = Math.floor(diffHour / 24)
  if (diffDay < 30) return `${diffDay}日前`

  const diffMonth = Math.floor(diffDay / 30)
  if (diffMonth < 12) return `${diffMonth}ヶ月前`

  return `${Math.floor(diffMonth / 12)}年前`
}
